var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F4F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.49 19.8086V19.81V28.19C33.49 29.9106 32.9791 31.2238 32.0964 32.1064C31.2138 32.9891 29.9006 33.5 28.18 33.5H19.81C18.0894 33.5 16.7763 32.9891 15.8938 32.1054C15.0111 31.2217 14.5 29.9059 14.5 28.18V19.81C14.5 18.0894 15.0109 16.7762 15.8936 15.8936C16.7762 15.0109 18.0894 14.5 19.81 14.5H28.19C29.9107 14.5 31.2237 15.011 32.105 15.8933C32.9861 16.7756 33.4947 18.0884 33.49 19.8086Z",
    fill: "#6F00FF",
    stroke: "#6F00FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 21.25H20.25C20.1161 21.25 20 21.1339 20 21C20 20.8661 20.1161 20.75 20.25 20.75H27.75C27.8839 20.75 28 20.8661 28 21C28 21.1339 27.8839 21.25 27.75 21.25Z",
    fill: "#6F00FF",
    stroke: "#6F00FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 27.25H20.25C20.1161 27.25 20 27.1339 20 27C20 26.8661 20.1161 26.75 20.25 26.75H27.75C27.8839 26.75 28 26.8661 28 27C28 27.1339 27.8839 27.25 27.75 27.25Z",
    fill: "#6F00FF",
    stroke: "#6F00FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditLine);
export default __webpack_public_path__ + "static/media/creditLine.59589544335f230bfd7aca41130bff08.svg";
export { ForwardRef as ReactComponent };